module.exports = __webpack_public_path__ + "static/bad-dog-studio-logo-02b4efd220efc51c5ea9a89d5b8079f2.png";